
<template>
    <div class="about-me-container">
        <div class="about-me">
            <div class="about-me__image">
                <responsive-image-reveal
                    :responsiveImage="responsiveImage"
                    :imageSizes="imageSizes"
                    imageAltText="A picture of me.">
                </responsive-image-reveal>
            </div>
            <div class="about-me__content">
                <p v-for="(item, index) in contentData.content" :key="index" v-html="item"></p>
            </div>
        </div>
    </div>
</template>

<script>
import breakpoints from '@/mixins/Breakpoints';
import responsiveImageReveal from '@/components/ResponsiveImageReveal.vue';

export default {
    mixins: [breakpoints],
    props: {
        contentData: Object,
    },
    components: {
        responsiveImageReveal,
    },
    computed: {
        // imageSizes - Generate a list of maximum image widths at each
        // breakpoint, this will be used in the 'sizes' attribute of the
        // 'srcset' for the image.
        imageSizes() {
            let imageSizes = '';

            imageSizes += `(min-width: ${this.breakpoints.sm}px) 300px, `; // sm - *
            imageSizes += `(min-width: ${this.breakpoints.ti}px) 150px, `; // ti - sm
            imageSizes += '120px'; // 0 - ti

            return imageSizes;
        },

        // responsiveImage - Generate a responsive image object with the
        // specified widths including 2x retina.
        // Widths: 120, 150, 300
        // Retina: 240, 300, 600
        responsiveImage() {
            // eslint-disable-next-line max-len
            return require('@/assets/img/about/me.png?sizes[]=120,sizes[]=150,sizes[]=240,sizes[]=300,sizes[]=600');
        },
    },
};
</script>

<style lang="scss">
    .about-me {
        @include mq($from: sm) {
            display: flex;
            flex-direction: row;
        }
    }

    .about-me__content {
        max-width: 50rem;

        @include mq($from: sm) {
            flex-grow: 1;
        }
    }

    .about-me__image {
        float: right;
        padding: 0 0 2rem 3rem;

        @include mq($from: sm) {
            order: 2;
            padding: 0 0 0 3rem;
        }

        @include mq($from: ml) {
            padding: 0 0 0 5rem;
        }

        .image-reveal {
            width: 12rem;

            @include mq($from: ti) {
                width: 15rem;
            }

            @include mq($from: sm) {
                width: 30rem;
            }
        }
    }
</style>
